/* Product-only Sowth runtime: PDP gallery guard + subtle commerce feedback. */
(function () {
  function guardMediaGallery() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('media-gallery').then(function () {
      try {
        var MG = customElements.get('media-gallery');
        if (!MG || !MG.prototype || MG.prototype.__sowthSlideGuard) return;
        var orig = MG.prototype.onSlideChanged;
        if (typeof orig !== 'function') return;
        MG.prototype.onSlideChanged = function (event) {
          if (!event || !event.detail || !event.detail.currentElement) return;
          try { return orig.call(this, event); } catch (e) {}
        };
        MG.prototype.__sowthSlideGuard = true;
      } catch (e) {}
    });
  }

  function flash(el, cls, delay) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    window.setTimeout(function () { el.classList.remove(cls); }, delay || 650);
  }

  function initFeedback() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var submit = form.querySelector('.product-form__submit');
    form.addEventListener('submit', function () {
      if (!submit || submit.disabled) return;
      flash(submit, 'is-sowth-submitting', 900);
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        flash(submit, 'is-sowth-added', 1200);
      });
    }
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('.product-form__input input[type="radio"], .product-form__input select')) return;
      var field = input.closest('.product-form__input');
      flash(field, 'is-sowth-choice-updated', 520);
    });
    document.addEventListener('click', function (event) {
      var control = event.target && event.target.closest ? event.target.closest('.quantity__button') : null;
      if (!control || !control.closest('.product')) return;
      flash(control.closest('.quantity'), 'is-sowth-qty-updated', 520);
    });
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('.product .quantity__input')) return;
      flash(input.closest('.quantity'), 'is-sowth-qty-updated', 520);
    });
  }

  guardMediaGallery();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFeedback);
  else initFeedback();
})();
